module.exports = __webpack_public_path__ + "static/img/m_home_advantage_technology@3x.20e1896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_home_advantage_technology@3x.png
// module id = D0S1
// module chunks = 1